import { VIEW_ONLY_DISABLED_MESSAGE } from '@mentimeter/editor-essentials/constants';
import { OverviewListViewOnly } from '@mentimeter/editor-overview-data-handlers';
import type { OverviewListItemType } from '@mentimeter/editor-overview-ui';
import type { Theme } from '@mentimeter/http-clients';
import { AddSlideButtonWithTooltip } from 'features/core/editor/Header/components/AddSlideButtonWithTooltip';

export const ViewOnlySlidesOverview = ({
  seriesTheme,
  activeQuestionId,
  overviewListItems,
  userIsViewOrCommentCollaborator,
  onClickSlideThumbnail,
  onClickCommentIcon,
  compactMode,
}: {
  seriesTheme: Theme;
  activeQuestionId: string;
  overviewListItems: OverviewListItemType[];
  userIsViewOrCommentCollaborator: boolean;
  onClickSlideThumbnail: (slideId: string) => void;
  onClickCommentIcon: () => void;
  compactMode: boolean;
}) => {
  return (
    <>
      {!compactMode && (
        <AddSlideButtonWithTooltip
          disabled={true}
          showAddSlidePopover={false}
          description={VIEW_ONLY_DISABLED_MESSAGE}
          showIconButton={compactMode}
        />
      )}
      <OverviewListViewOnly
        seriesTheme={seriesTheme}
        activeQuestionId={activeQuestionId}
        overviewListItems={overviewListItems}
        userIsViewOrCommentCollaborator={userIsViewOrCommentCollaborator}
        onClickSlideThumbnail={onClickSlideThumbnail}
        onClickCommentIcon={onClickCommentIcon}
        compactMode={compactMode}
      />
    </>
  );
};
